export default {
  admin: () => import('./admin.js'),
  user: () => import('./user.js'),
};
